import { render, staticRenderFns } from "./photoInfo.vue?vue&type=template&id=6660c5b9"
import script from "./photoInfo.vue?vue&type=script&lang=js"
export * from "./photoInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports